import React from 'react';
import './HeroButton.scss';

import { motion } from 'framer-motion';
interface HeroBtn {
  text: string;
  link?: string;
  icon?: string;
}

export default function HeroButton({ text, link, icon }: HeroBtn) {
  return (
    <motion.a
      href={link || '#'}
      className='btn-icon'
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {icon === 'gridSvg' ? (
        <svg
          //   width='15'
          //   height='15'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 512 512'
        >
          <path
            className='fa-secondary'
            d='M306.67 352H205.33a24 24 0 0 0-24 24v80a24 24 0 0 0 24 24h101.34a24 24 0 0 0 24-24v-80a24 24 0 0 0-24-24zM488 192H386.67a24 24 0 0 0-24 24v80a24 24 0 0 0 24 24H488a24 24 0 0 0 24-24v-80a24 24 0 0 0-24-24zM306.67 32H205.33a24 24 0 0 0-24 24v80a24 24 0 0 0 24 24h101.34a24 24 0 0 0 24-24V56a24 24 0 0 0-24-24zM125.33 192H24a24 24 0 0 0-24 24v80a24 24 0 0 0 24 24h101.33a24 24 0 0 0 24-24v-80a24 24 0 0 0-24-24z'
          ></path>
          <path
            className='fa-primary'
            d='M488 352H386.67a24 24 0 0 0-24 24v80a24 24 0 0 0 24 24H488a24 24 0 0 0 24-24v-80a24 24 0 0 0-24-24zM306.67 192H205.33a24 24 0 0 0-24 24v80a24 24 0 0 0 24 24h101.34a24 24 0 0 0 24-24v-80a24 24 0 0 0-24-24zM488 32H386.67a24 24 0 0 0-24 24v80a24 24 0 0 0 24 24H488a24 24 0 0 0 24-24V56a24 24 0 0 0-24-24zm-362.67 0H24A24 24 0 0 0 0 56v80a24 24 0 0 0 24 24h101.33a24 24 0 0 0 24-24V56a24 24 0 0 0-24-24zm0 320H24a24 24 0 0 0-24 24v80a24 24 0 0 0 24 24h101.33a24 24 0 0 0 24-24v-80a24 24 0 0 0-24-24z'
          ></path>
        </svg>
      ) : icon === 'arrows' ? (
        <svg
          //   width='15'
          //   height='15'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 512 512'
        >
          <path
            className='fa-secondary'
            d='M224 273L88.37 409a23.78 23.78 0 0 1-33.8 0L32 386.36a23.94 23.94 0 0 1 0-33.89l96.13-96.37L32 159.73a23.94 23.94 0 0 1 0-33.89l22.44-22.79a23.78 23.78 0 0 1 33.8 0L223.88 239a23.94 23.94 0 0 1 .1 34z'
          ></path>
          <path
            className='fa-primary'
            d='M415.89 273L280.34 409a23.77 23.77 0 0 1-33.79 0L224 386.26a23.94 23.94 0 0 1 0-33.89L320.11 256l-96-96.47a23.94 23.94 0 0 1 0-33.89l22.52-22.59a23.77 23.77 0 0 1 33.79 0L416 239a24 24 0 0 1-.11 34z'
          ></path>
        </svg>
      ) : icon === 'plan-project' ? (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'>
          <path
            className='fa-secondary'
            d='M382.758 199.143L504.625 52.186C521.965 31.275 506.787 0 479.299 0H32.701C5.213 0-9.965 31.275 7.375 52.186L192 274.822V368c0 7.828 3.813 15.172 10.25 19.656l66.875 46.799C260.719 413.93 256 391.516 256 368c0-79.943 53.625-147.49 126.758-168.857z'
          ></path>
          <path
            className='fa-primary'
            d='M432.002 224C352.463 224 288 288.463 288 368s64.463 144 144.002 144C511.537 512 576 447.537 576 368s-64.463-144-143.998-144zm52.625 180.75c-3.109 17.969-17.033 29.619-36.594 33.473V448c0 8.844-7.156 16-16 16s-16-7.156-16-16v-10.084c-9.816-2.025-19.166-5.441-26.719-8.166-8.343-2.953-12.687-12.094-9.75-20.422 2.969-8.328 12.219-12.625 20.438-9.734 16.205 5.806 19.953 6.89 24.844 7.625 13.125 2.093 26.875 0 28.218-7.922 1.684-9.633-12.259-12.113-30.531-17.391-14.781-4.344-49.406-14.5-43.125-50.672 3.094-18.045 16.875-30.031 36.625-33.816V288c0-8.844 7.156-16 16-16s16 7.156 16 16v10.223c5.647 1.179 11.522 2.632 17.219 4.621 8.344 2.89 12.75 12 9.875 20.359-2.938 8.36-12 12.797-20.375 9.86-5.219-1.797-10.719-3.516-15.719-4.313-12.844-1.984-26.75.063-28.125 7.953-1.543 9.193 11.229 11.756 25.469 15.891 20.406 5.828 54.562 15.594 48.25 52.156z'
          ></path>
        </svg>
      ) : (
        ''
      )}
      <span>{text}</span>
    </motion.a>
  );
}
